import React from 'react';
import LandingPage from './LandingPage';

const HalifaxBartender = () => {
  return <LandingPage />;
};

export default HalifaxBartender;